import { useLocalization } from "@fluent/react";
import { Chip } from "@mui/material";
import { getPriorityChipConfig } from "../helpers/companyBugHelpers";

type Props = {
    priority: string | null | undefined;
    showPrefix?: boolean;
};

export const CompanyBugPriorityChip = ({ priority, showPrefix = false }: Props) => {
    const { l10n } = useLocalization();
    const { l10nId, fallback, color } = getPriorityChipConfig(priority);
    const value = l10nId ? l10n.getString(l10nId, null, fallback) : fallback;
    const label = showPrefix
        ? `${l10n.getString("bug-report-list-priority", null, "Priority")}: ${value}`
        : value;

    return <Chip label={label} color={color} size="small" variant="outlined" />;
};
